"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollService = exports.ScrollTargetEnum = exports.ScrollDurationEnum = exports.ScrollDirectionEnum = void 0;
const animejs_1 = require("animejs");
const app_1 = require("app");
var ScrollDirectionEnum;
(function (ScrollDirectionEnum) {
    ScrollDirectionEnum["Top"] = "scrollTop";
    ScrollDirectionEnum["Left"] = "scrollLeft";
})(ScrollDirectionEnum || (exports.ScrollDirectionEnum = ScrollDirectionEnum = {}));
var ScrollDurationEnum;
(function (ScrollDurationEnum) {
    ScrollDurationEnum[ScrollDurationEnum["Slow"] = 600] = "Slow";
    ScrollDurationEnum[ScrollDurationEnum["Fast"] = 300] = "Fast";
    ScrollDurationEnum[ScrollDurationEnum["SuperFast"] = 200] = "SuperFast";
})(ScrollDurationEnum || (exports.ScrollDurationEnum = ScrollDurationEnum = {}));
var ScrollTargetEnum;
(function (ScrollTargetEnum) {
    ScrollTargetEnum["Top"] = "top";
    ScrollTargetEnum["Bottom"] = "bottom";
})(ScrollTargetEnum || (exports.ScrollTargetEnum = ScrollTargetEnum = {}));
const DESKTOP_GUTTER = 48;
const MOBILE_GUTTER = 32;
class ScrollService {
    constructor() {
        this.gutter = DESKTOP_GUTTER;
        this.isBusy = false;
        this.lastScrollValue = NaN;
        this.GoToElement = (element, extraGutter = 0, checkForPause = true) => {
            this.isBusy = true;
            const scrollTopValue = this.calculateScrollValue(ScrollTargetEnum.Top, element, extraGutter);
            this.lastScrollValue = scrollTopValue;
            this.scroll(ScrollDirectionEnum.Top, scrollTopValue, ScrollDurationEnum.Fast, () => this.onScrollEnd(ScrollDurationEnum.Fast, scrollTopValue), checkForPause);
        };
        this.GoToBottomOfElement = (element, extraGutter = 0, checkForPause = true) => {
            this.isBusy = true;
            const scrollTopValue = this.calculateScrollValue(ScrollTargetEnum.Bottom, element, extraGutter);
            this.lastScrollValue = scrollTopValue;
            this.scroll(ScrollDirectionEnum.Top, scrollTopValue, ScrollDurationEnum.Fast, () => this.onScrollEnd(ScrollDurationEnum.Fast, scrollTopValue), checkForPause);
        };
        this.GoToAnchor = (hash, event) => {
            if (!hash || hash === '#' || this.isBusy) {
                return;
            }
            const el = document.querySelector(`${hash}`);
            if (!el) {
                return;
            }
            if ('scrollRestoration' in globalThis.history) {
                globalThis.history.scrollRestoration = 'manual';
            }
            event === null || event === void 0 ? void 0 : event.preventDefault();
            globalThis.history.replaceState(null, '', hash);
            this.GoToElement(el);
        };
        this.GoToPosition = (scrollDirection, scrollValue, duration, element = 'html, body', checkForPause = true) => {
            this.scroll(scrollDirection, scrollValue, duration, () => this.onScrollEnd(duration, scrollValue), checkForPause, element);
        };
        this.scroll = (scrollProperty, scrollValue, duration, onComplete, checkForPause = true, element = 'html, body') => {
            setTimeout(() => {
                if (this.animationObject && checkForPause) {
                    this.animationObject.pause();
                }
                this.animationObject = (0, animejs_1.default)({
                    targets: element,
                    [scrollProperty]: scrollValue,
                    easing: 'linear',
                    duration,
                    complete: onComplete,
                });
            }, 50); // change timeout 0 => 50 ms to fix animation in firefox
        };
        this.calculateScrollValue = (scrollTarget, element, extraGutter = 0) => {
            if (scrollTarget === ScrollTargetEnum.Top) {
                const calculatedHeaderAndTabsHeight = this.calculateHeaderAndTabsHeight();
                return (element.getBoundingClientRect().top +
                    globalThis.scrollY -
                    calculatedHeaderAndTabsHeight -
                    this.gutter -
                    extraGutter);
            }
            if (scrollTarget === ScrollTargetEnum.Bottom) {
                return (element.getBoundingClientRect().bottom +
                    globalThis.scrollY -
                    (window.innerHeight - this.gutter - extraGutter));
            }
            return 0;
        };
        this.calculateHeaderAndTabsHeight = () => {
            const stickyTabsHeight = this.stickyTabs ? this.stickyTabs.clientHeight : 0;
            const headerHeight = this.header ? this.header.getBoundingClientRect().bottom : 0;
            return headerHeight + stickyTabsHeight;
        };
        this.updateGutter = () => {
            if ((0, app_1.isMobile)()) {
                this.gutter = MOBILE_GUTTER;
            }
            else {
                this.gutter = DESKTOP_GUTTER;
            }
        };
        this.onWindowResizeThrottle = (0, app_1.throttle)(this.updateGutter);
        this.onScrollEnd = (delay, scrollValue) => {
            setTimeout(() => {
                if (scrollValue === this.lastScrollValue) {
                    this.isBusy = false;
                    this.animationObject = null;
                }
            }, delay);
        };
        this.header = document.querySelector('.header');
        this.stickyTabs = document.querySelector('.sticky-tabs');
        this.updateGutter();
        globalThis.addEventListener('resize', this.onWindowResizeThrottle);
    }
}
exports.scrollService = new ScrollService();
